import { adminService } from 'core/services/adminService'
import { formatNumbers } from 'core/helpers/format-numbers'
import { useState } from 'react'

import c from './assets/sass/task-item.module.scss'

const TASK_TYPES = {
    DAILY_LOGIN: '📅 Ежедневный вход',
    REFER_FRIENDS: '👥 Пригласить друзей',
    PLAY_MINES: '💣 Сыграть в Мины',
    PLAY_BATTLE: '⚔️ Сыграть в Битву',
    OPEN_CASES: '🎁 Открыть кейс',
    TAP_ENERGY: '⚡ Тапнуть',
    TELEGRAM_CHANNEL: '📢 Подписка на Telegram канал',
    EXTERNAL_LINK: '🔗 Перейти по ссылке',
}

export const TaskItem = ({ task, onEdit, onUpdate }) => {
    const [loading, setLoading] = useState(false)

    const toggleActive = async () => {
        try {
            setLoading(true)
            await adminService.updateTask(task.id, {
                ...task,
                isActive: !task.isActive,
            })
            onUpdate()
        } catch (error) {
            alert('Ошибка: ' + error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async () => {
        if (!window.confirm(`Удалить задание "${task.title}"?`)) return
        try {
            setLoading(true)
            await adminService.deleteTask(task.id)
            onUpdate()
        } catch (error) {
            alert('Ошибка: ' + error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className={c.component}>
            <div className={c.header}>
                <span className={c.type}>
                    {TASK_TYPES[task.type] || task.type}
                </span>
                <span className={c.completed}>
                    {task.completedCount} выполнено
                </span>
            </div>
            <div className={c.content}>
                <span className={c.title}>{task.title}</span>
                <span className={c.description}>{task.description}</span>
                <div className={c.rewards}>
                    {parseInt(task.reward) > 0 && (
                        <span className={c.reward}>
                            💰 {formatNumbers(parseInt(task.reward))}
                        </span>
                    )}
                    {task.energyReward > 0 && (
                        <span className={c.reward}>⚡ {task.energyReward}</span>
                    )}
                </div>
                {task.url && <span className={c.url}>🔗 {task.url}</span>}
            </div>
            <div className={c.actions}>
                <button className={c.btn} onClick={onEdit}>
                    Редактировать
                </button>
                <button
                    className={`${c.btn} ${task.isActive ? c.btnWarning : c.btnSuccess}`}
                    onClick={toggleActive}
                    disabled={loading}
                >
                    {task.isActive ? 'Выключить' : 'Включить'}
                </button>
                <button
                    className={`${c.btn} ${c.btnDanger}`}
                    onClick={handleDelete}
                    disabled={loading}
                >
                    Удалить
                </button>
            </div>
        </div>
    )
}
